<template>
    <MainPage @clickBack="clickBack()" customClass="lg:max-w-xl">
        <div class="p-4">
            <TaxAddressList
                ref="tax-list"
                @onEditAddress="clickEditAddress($event)"
                @onDeleteAddress="clickDeleteAddress($event)"
            ></TaxAddressList>
            <div class="w-56 lg:w-60 mx-auto pt-4">
                <WhiteButton @click="clickAddAddress()"
                    customClass="flex py-2 px-8 mx-auto">
                    <img class="my-auto ml-auto mr-2" src="@/assets/icon/ic-add-red-2.svg" />
                    <div class="my-auto ml-0 mr-auto text-a-red-d62300 text-14 lg:text-16 font-bold">{{lbl.tax.btn_add_tax_address}}</div>
                </WhiteButton>
            </div>
        </div>
    </MainPage>
</template>
<script>
import Util from "@/helper/Utility";
//mixin
import LocaleMixin from "@/mixin/LocaleMixin";
import ModalMixin from "@/mixin/ModalMixin.js";
//component
import MainPage from "@/components/Layout/Page/MainPage.vue";
import WhiteButton from "@/components/Button/WhiteButton.vue";
import TaxAddressList from "../component/TaxAddressList.vue";
//service
import BzbsAddressList from "@/core/Address/service/BzbsAddressList.js";

export default {
    name: "TaxAddress",
    mixins: [LocaleMixin, ModalMixin],
    inject: ['DeliveryStore'],
    components: {
        MainPage,
        WhiteButton,
        TaxAddressList,
    },
    methods: {
        //#region mixin function
        onSetupModalCompleted: function() {
            this.initialTaxAddressModal();
        },
        //#endregion mixin function

        reloadAddressList: function() {
            this.$refs['tax-list'].getAddressList();
        },
        clickAddAddress: function() {
            this.DeliveryStore.methods.removeTaxAddress();
            this.$router.push('/addtaxaddress')
        },
        clickEditAddress: function(address) {
            this.DeliveryStore.methods.initTaxAddress();
            this.DeliveryStore.state.taxAddress = address;
            this.$router.push('/edittaxaddress');
        },
        clickDeleteAddress: function(address) {
            this.modal.confirmModal.clearModal()
                    .setMsg(Util.stringFormat(this.lbl.tax.modal_del_msg, address.taxName))
                    .setBtnOk(this.lbl.tax.confirm_del_btn)
                    .show()
            this.modal.confirmModal.onClickOk(() => {
                this.apiDeleteAddress(address);
            });
        },
        apiDeleteAddress: function(address) {
            this.modal.loadingModal.show();

            BzbsAddressList.apiDeleteTaxAddress(address.rowKey).subscribe({
                next: () => {
                    this.modal.loadingModal.hide();
                    this.reloadAddressList();
                },
                error: (err) => {
                    this.modal.loadingModal.hide();
                    this.errorApi(err);
                },
            });
        },

        clickListAddressModal: function() {
            this.modal.listTaxAddressModal.show();
        },
        clickBack: function() {
            this.$router.back();
        },
    },
}
</script>
<style lang="scss" scoped>

</style>
